export const BUTTON_LINK_OFFERS = 'https://cian.onelink.me/E1Os/t30d387h';

export const BUTTON_LINK_OFFERS_WEBVIEW =
  'cianurl://my.cian.ru/my-offers/?tab=sale&offerType=flat&sortType=publishedDate';
